// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyA5JZ4sQfQgGXSFTbtArpDQzWL_fdB1zAg",
  authDomain: "salesroute-d2049.firebaseapp.com",
  projectId: "salesroute-d2049",
  storageBucket: "salesroute-d2049.firebasestorage.app",
  messagingSenderId: "533110140468",
  appId: "1:533110140468:web:e275527e71ec76e9a92461",
  measurementId: "G-X7HE29MXB0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app)


export const generateToken = async () =>{
    const permission = await Notification.requestPermission();
    // console.log(permission)
    if(permission === 'granted'){
        const token = await getToken(messaging,{
            vapidKey:
                "BEwCUDWooMz49A_tRzrZbhx0fs68w1pOsjNwUPoFuqX5_4QRsCGXN1cadAfiUE3dfxkRLVOr8GXNwin91U52fis",
        });
        // console.log(token)
    }

}
